export default __webpack_public_path__ + "static/media/warning_icon.863a8c15.svg";